import script from "./AppTagSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTagSelector.vue?vue&type=script&setup=true&lang=ts"

import "./AppTagSelector.vue?vue&type=style&index=0&id=92af94f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92af94f6"]])

export default __exports__